export default function() {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve({
                x: 0,
                y: 0
            })
        }, 300)
    })
}